import React, { useContext } from "react";
import { Accordion, Card, AccordionContext } from "react-bootstrap";
import { Tooltip, Text } from "../";
import "./accordion.css";
import AccordionToggle from "./AccordionToggle";

/**
 * AccordionContent component uses with Accordion component.
 * Inludes holder, header and collapse.
 * Holder: container of header and collapse
 * Header: title and extra buttons. Open-close collapse button.
 * Collapse: content holder. Can take component.
 */
const AccordionContent = (props) => {
  const {
    pluginId,
    holderClass = "",
    holderStyle,
    headerClass = "",
    headerStyle,
    titleClass = "",
    collapseClass = "",
    collapseStyle,
    tooltipPlacement = "topLeft",
    title,
    eventKey,
    draggable,
    onDragStart,
    onDragEnd,
    onClick,
    onDblClick,
    arrow,
    arrowClass,
    icon,
    extra,
    children
  } = props;

  const activeKey = useContext(AccordionContext);
  const isExpanded = Array.isArray(activeKey)
    ? activeKey.includes(eventKey)
    : activeKey === eventKey;

  const tooltipClassName = `accordion-content-tooltip${pluginId ? ' accordion-content-' + pluginId : ''}`;

  const holderClassResult = `accordion-holder ${holderClass} ${isExpanded ? "active" : ""}`.trim();
  const titleClassResult = `collapse-title ${titleClass}`.trim();
  const collapseClassResult = `accordion-collapse ${collapseClass}`.trim();

  const headerContent = (
    <>
      <AccordionToggle
        eventKey={eventKey}
        draggable={draggable}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onClick={() => onClick instanceof Function && onClick()}
        onDoubleClick={onDblClick}
        className={headerClass}
        style={headerStyle || null}
      >
        {arrow !== false && (
          <div className="collapse-icon">
            <i className={arrowClass || "fas fa-chevron-down"}></i>
          </div>
        )}
        <div className={titleClassResult}>
          {icon && <span className="accordion-icon">{icon}</span>}
          <Text
            id={title}
            type="span"
            className="text-shorten"
          >
            {title}
          </Text>
        </div>
        {extra && (
          <div className="accordion-extra" onClick={(e) => e.stopPropagation()}>
            {extra}
          </div>
        )}
      </AccordionToggle>
    </>
  );

  return (
    <div className={holderClassResult} style={holderStyle || null}>
      {title ? (
        <Tooltip
          placement={tooltipPlacement}
          title={title}
          overlayClassName={tooltipClassName}
        >
          {headerContent}
        </Tooltip>
      ) : (
        headerContent
      )}
      <Accordion.Collapse
        className={collapseClassResult}
        style={collapseStyle || null}
        eventKey={eventKey}
      >
        <Card.Body>{children}</Card.Body>
      </Accordion.Collapse>
    </div>
  );
};

export default AccordionContent;
